"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = require("../constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _default(theme, props, state) {
  var palette = theme.palette;

  if (props.dark) {
    theme.color = theme.darkColor;
    theme.borderColor = theme.darkBorderColor;
    theme.background = theme.darkBackground;
  }

  var labelStyle = {
    whiteSpace: 'normal',
    wordWrap: 'normal'
  };

  if (props["short"]) {
    theme.maxWidth = palette.gutter * 40 + 'px';
    theme.minWidth = palette.gutter * 20 + 'px';
  } else if (props.middle) {
    theme.maxWidth = palette.gutter * 60 + 'px';
    theme.minWidth = palette.gutter * 40 + 'px';
  } else if (props["long"]) {
    theme.maxWidth = palette.gutter * 70 + 'px';
    theme.minWidth = palette.gutter * 50 + 'px';
  } else if (props.wide) {
    theme.maxWidth = 'auto';
    theme.minWidth = 'auto';
  }

  if (!props.multiLine) {
    labelStyle = {
      textWrap: 'none',
      whiteSpace: 'nowrap',
      wordWrap: 'normal'
    };
  }

  if (props.inline) {
    theme.display = 'inline-block';
  }

  var position = {
    top: 0,
    left: "calc(100% + ".concat(palette.gutter * 2, "px)"),
    right: 'auto',
    bottom: 'auto'
  };
  var trianglePosition = {
    left: theme.triangleWidth * -1 + 'px',
    top: theme.triangleWidth * -1 + 'px',
    right: 'auto',
    bottom: 'auto'
  };

  if (state.position === _constants.POSITION_TOP_LEFT) {
    position = {
      top: 'auto',
      left: 0,
      right: 'auto',
      bottom: "calc(100% + ".concat(palette.gutter * 2, "px)")
    };
    trianglePosition = {
      left: "calc(15% - ".concat(theme.triangleWidth / 2, "px)"),
      right: 'auto',
      top: 'auto',
      bottom: theme.triangleWidth * -1 + 'px'
    };
  } else if (state.position === _constants.POSITION_TOP_RIGHT) {
    position = {
      top: 'auto',
      right: 0,
      left: 'auto',
      bottom: "calc(100% + ".concat(palette.gutter * 2, "px)")
    };
    trianglePosition = {
      right: "calc(15% - ".concat(theme.triangleWidth / 2, "px)"),
      left: 'auto',
      top: 'auto',
      bottom: theme.triangleWidth * -1 + 'px'
    };
  } else if (state.position === _constants.POSITION_RIGHT_TOP) {
    position = {
      top: 0,
      right: 'auto',
      left: "calc(100% + ".concat(palette.gutter * 2, "px)"),
      bottom: 'auto'
    };
    trianglePosition = {
      left: theme.triangleWidth * -1 + 'px',
      right: 'auto',
      top: "calc(15% - ".concat(theme.triangleWidth / 2, "px)"),
      bottom: 'auto'
    };
  } else if (state.position === _constants.POSITION_RIGHT_BOTTOM) {
    position = {
      top: 'auto',
      right: 'auto',
      left: "calc(100% + ".concat(palette.gutter * 2, "px)"),
      bottom: 0
    };
    trianglePosition = {
      left: theme.triangleWidth * -1 + 'px',
      right: 'auto',
      top: 'auto',
      bottom: "calc(15% - ".concat(theme.triangleWidth / 2, "px)")
    };
  } else if (state.position === _constants.POSITION_BOTTOM_RIGHT) {
    position = {
      top: "calc(100% + ".concat(palette.gutter * 2, "px)"),
      right: 0,
      left: 'auto',
      bottom: 'auto'
    };
    trianglePosition = {
      top: theme.triangleWidth * -1 + 'px',
      right: "calc(15% - ".concat(theme.triangleWidth / 2, "px)"),
      left: 'auto',
      bottom: 'auto'
    };
  } else if (state.position === _constants.POSITION_BOTTOM_LEFT) {
    position = {
      top: "calc(100% + ".concat(palette.gutter * 2, "px)"),
      right: 'auto',
      left: 0,
      bottom: 'auto'
    };
    trianglePosition = {
      top: theme.triangleWidth * -1 + 'px',
      right: 'auto',
      left: "calc(15% - ".concat(theme.triangleWidth / 2, "px)"),
      bottom: 'auto'
    };
  } else if (state.position === _constants.POSITION_LEFT_TOP) {
    position = {
      top: 0,
      left: 'auto',
      right: "calc(100% + ".concat(palette.gutter * 2, "px)"),
      bottom: 'auto'
    };
    trianglePosition = {
      left: 'auto',
      right: theme.triangleWidth * -1 + 'px',
      top: "calc(15% - ".concat(theme.triangleWidth / 2, "px)"),
      bottom: 'auto'
    };
  } else if (state.position === _constants.POSITION_LEFT_BOTTOM) {
    position = {
      top: 'auto',
      left: 'auto',
      right: "calc(100% + ".concat(palette.gutter * 2, "px)"),
      bottom: 0
    };
    trianglePosition = {
      left: 'auto',
      right: theme.triangleWidth * -1 + 'px',
      top: 'auto',
      bottom: "calc(15% - ".concat(theme.triangleWidth / 2, "px)")
    };
  } else if (state.position === _constants.POSITION_TOP_CENTER) {
    position = {
      top: 'auto',
      left: '50%',
      right: 'auto',
      transform: 'translateX(-50%)',
      bottom: "calc(100% + ".concat(palette.gutter * 2, "px)")
    };
    trianglePosition = {
      left: '50%',
      right: 'auto',
      top: 'auto',
      transform: 'translateX(-50%)',
      bottom: theme.triangleWidth * -1 + 'px'
    };
  } else if (state.position === _constants.POSITION_BOTTOM_CENTER) {
    position = {
      top: "calc(100% + ".concat(palette.gutter * 2, "px)"),
      left: '50%',
      right: 'auto',
      transform: 'translateX(-50%)',
      bottom: "auto"
    };
    trianglePosition = {
      left: '50%',
      right: 'auto',
      top: theme.triangleWidth * -1 + 'px',
      transform: 'translateX(-50%)',
      bottom: 'auto'
    };
  } else if (state.position === _constants.POSITION_LEFT_CENTER) {
    position = {
      top: "50%",
      left: 'auto',
      right: "calc(100% + ".concat(palette.gutter * 2, "px)"),
      transform: 'translateY(-50%)',
      bottom: "auto"
    };
    trianglePosition = {
      left: 'auto',
      right: theme.triangleWidth * -1 + 'px',
      top: "50%",
      transform: 'translateY(-50%)',
      bottom: 'auto'
    };
  } else if (state.position === _constants.POSITION_RIGHT_CENTER) {
    position = {
      top: "50%",
      left: "calc(100% + ".concat(palette.gutter * 2, "px)"),
      right: "auto",
      transform: 'translateY(-50%)',
      bottom: "auto"
    };
    trianglePosition = {
      left: theme.triangleWidth * -1 + 'px',
      right: 'auto',
      top: "50%",
      transform: 'translateY(-50%)',
      bottom: 'auto'
    };
  }

  if (theme.top || theme.left) {
    position.transform = "translateX(".concat(theme.left || 0, "px) translateY(").concat(theme.top || 0, "px)");
  }

  return {
    root: {
      position: 'relative',
      display: theme.display,
      textAlign: theme.textAlign,
      width: theme.width
    },
    wrapper: _objectSpread({
      position: 'absolute',
      boxSizing: 'border-box',
      zIndex: theme.zIndex,
      whiteSpace: 'normal',
      boxShadow: theme.boxShadow
    }, position, {
      '&:before': {
        display: 'block',
        content: '""',
        width: "calc(100% + ".concat(palette.gutter * 4, "px)"),
        height: "calc(100% + ".concat(palette.gutter * 4, "px)"),
        position: 'absolute',
        top: "-".concat(palette.gutter * 2, "px"),
        left: "-".concat(palette.gutter * 2, "px"),
        zIndex: theme.zIndex - 1
      }
    }),
    triangle: _objectSpread({
      position: 'absolute',
      width: theme.triangleWidth * 2 + 'px',
      height: theme.triangleWidth * 2 + 'px',
      background: theme.background
    }, trianglePosition, {
      transform: (trianglePosition.transform || '') + ' rotate(45deg)',
      border: '0 none',
      boxShadow: theme.boxShadow,
      zIndex: 1
    }),
    label: _objectSpread({}, labelStyle, {
      padding: palette.gutter + 'px',
      fontSize: theme.labelFontSize,
      lineHeight: theme.labelLineHeight,
      color: theme.color,
      textAlign: theme.textAlign,
      textTransform: 'none',
      maxWidth: theme.maxWidth,
      minWidth: theme.minWidth,
      zIndex: 2,
      backgroundColor: theme.background,
      border: "1px solid ".concat(theme.borderColor),
      borderRadius: '2px',
      position: 'relative',
      '& a': {
        color: theme.linkColor,
        textDecoration: 'none'
      }
    })
  };
}